module.exports = __webpack_public_path__ + "static/media/cara-galery-2.a1e1fc24.png";